import { useEffect, useState } from 'react';

interface CountdownOptions {
  initialSeconds: number;
  onComplete?: () => void;
  onTick?: (remainingSeconds: number) => void;
}

export const useCountdown = ({
  initialSeconds,
  onComplete,
  onTick,
}: CountdownOptions) => {
  const [seconds, setSeconds] = useState(0);
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    let timer: number;

    if (isRunning && seconds > 0) {
      timer = window.setInterval(() => {
        setSeconds((currentSeconds) => {
          const newSeconds = currentSeconds - 1;
          if (onTick) {
            onTick(newSeconds);
          }
          if (newSeconds === 0) {
            setIsRunning(false);
            if (onComplete) {
              onComplete();
            }
          }
          return newSeconds;
        });
      }, 1000);
    }

    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRunning, seconds]);

  const start = () => {
    setSeconds(initialSeconds);
    if (initialSeconds === 0) {
      setIsRunning(false);
      if (onComplete) {
        onComplete();
      }
    } else {
      setIsRunning(true);
    }
  };

  const stop = () => {
    setIsRunning(false);
    setSeconds(0);
  };

  const pause = () => {
    setIsRunning(false);
  };

  const resume = () => {
    if (seconds > 0) {
      setIsRunning(true);
    }
  };

  return {
    seconds,
    isRunning,
    start,
    stop,
    pause,
    resume,
  };
};
